let idCounter = 100

export function generateId() {
  // 基于时间戳+计数器+随机数，避免页面刷新后与已存储的ID冲突
  idCounter++
  return Date.now().toString(36) + '_' + idCounter + '_' + Math.random().toString(36).slice(2, 6)
}

export const defaultAssistants = [
  { id: 1, name: '默认助手', icon: '😊', description: '通用 AI 助手' }
]

export const defaultTopics = [
  { id: 1, assistantId: 1, title: '新对话', updatedAt: Date.now() }
]

export const assistantCategories = [
  { key: 'all', label: '全部' },
  { key: 'media', label: '自媒体' },
  { key: 'finance', label: '金融' },
  { key: 'law', label: '法律' },
  { key: 'internet', label: '互联网' },
  { key: 'research', label: '科研' },
  { key: 'education', label: '教育' },
  { key: 'medical', label: '健康医疗' },
  { key: 'life', label: '生活服务' },
  { key: 'tools', label: '通用工具' },
  { key: 'other', label: '其它' }
]

export const assistantSubTypes = [
  { key: 'pack', label: '技能包', icon: '📦' },
  { key: 'dataset', label: '数据集', icon: '🗂' },
  { key: 'dev', label: '开发辅助', icon: '🛠' },
  { key: 'office', label: '办公效率', icon: '📝' },
  { key: 'analysis', label: '数据分析', icon: '📊' },
  { key: 'media', label: '影音娱乐', icon: '🎬' }
]

export const assistantTemplates = [
  {
    id: 'tpl-1',
    name: 'A股投资分析技能包',
    icon: '📈',
    description: '基于深度量化策略与多维数据...',
    category: 'finance',
    subType: 'pack',
    downloadCount: '14.9w',
    isPaid: false,
    skills: [
      { name: '板块热度分析', icon: '🔥' },
      { name: '科技股分析', icon: '🔍' },
      { name: '技术形态识别', icon: '📊' },
      { name: '财报解读', icon: '📋' }
    ]
  },
  {
    id: 'tpl-2',
    name: '全能法务助理技能包',
    icon: '⚖️',
    description: '专为法务从业者、律师与企业...',
    category: 'law',
    subType: 'pack',
    downloadCount: '4.9w',
    isPaid: false,
    skills: [
      { name: '法律咨询报告', icon: '📝' },
      { name: '诉讼大师', icon: '⚖️' },
      { name: '合同审查', icon: '📄' },
      { name: '法规检索', icon: '📚' }
    ]
  },
  {
    id: 'tpl-3',
    name: '调研分析技能包',
    icon: '💡',
    description: '融数据挖掘、商业咨询与市场...',
    category: 'tools',
    subType: 'pack',
    downloadCount: '5.4w',
    isPaid: true,
    skills: [
      { name: '超级分析师', icon: '🔍' },
      { name: '行业趋势深度调研', icon: '📊' },
      { name: '竞品分析', icon: '🏢' },
      { name: '用户画像分析', icon: '👥' }
    ]
  },
  {
    id: 'tpl-4',
    name: '科研助理技能包',
    icon: '🔬',
    description: '聚合全球顶尖开放学术图谱与...',
    category: 'research',
    subType: 'pack',
    downloadCount: '2.9w',
    isPaid: false,
    skills: [
      { name: 'arXiv 论文数据搜索', icon: '📄' },
      { name: '学术趋势分析', icon: '📈' },
      { name: '文献综述生成', icon: '📝' },
      { name: '引用网络分析', icon: '🕸' }
    ]
  },
  {
    id: 'tpl-5',
    name: '自媒体创作技能包',
    icon: '📱',
    description: '一站式自媒体内容创作与运营...',
    category: 'media',
    subType: 'pack',
    downloadCount: '22.3w',
    isPaid: false,
    skills: [
      { name: '爆款文案生成', icon: '✍️' },
      { name: '短视频脚本', icon: '🎬' },
      { name: 'SEO 标题优化', icon: '🔍' },
      { name: '评论互动管理', icon: '💬' }
    ]
  },
  {
    id: 'tpl-6',
    name: 'Python 开发技能包',
    icon: '🐍',
    description: 'Python 全栈开发，从入门到精通...',
    category: 'internet',
    subType: 'dev',
    downloadCount: '18.6w',
    isPaid: false,
    skills: [
      { name: '代码审查', icon: '🔍' },
      { name: '算法实现', icon: '🧮' },
      { name: '调试辅助', icon: '🐛' },
      { name: '代码重构', icon: '🔧' }
    ]
  },
  {
    id: 'tpl-7',
    name: '英语学习技能包',
    icon: '📚',
    description: '沉浸式英语学习，听说读写全面...',
    category: 'education',
    subType: 'pack',
    downloadCount: '31.2w',
    isPaid: true,
    skills: [
      { name: '口语陪练', icon: '🗣' },
      { name: '写作批改', icon: '✍️' },
      { name: '词汇记忆', icon: '📖' },
      { name: '听力训练', icon: '🎧' }
    ]
  },
  {
    id: 'tpl-8',
    name: '健康咨询技能包',
    icon: '🏥',
    description: '专业健康咨询与医疗知识问答...',
    category: 'medical',
    subType: 'pack',
    downloadCount: '7.8w',
    isPaid: false,
    skills: [
      { name: '症状自查', icon: '🩺' },
      { name: '用药咨询', icon: '💊' },
      { name: '健康计划', icon: '💪' },
      { name: '营养建议', icon: '🥗' }
    ]
  },
  {
    id: 'tpl-9',
    name: 'PPT 办公技能包',
    icon: '📊',
    description: '高效办公必备，PPT 快速生成与...',
    category: 'tools',
    subType: 'office',
    downloadCount: '42.1w',
    isPaid: false,
    skills: [
      { name: 'PPT 大纲生成', icon: '📋' },
      { name: '图表美化', icon: '🎨' },
      { name: '演讲稿撰写', icon: '🎤' },
      { name: '模板推荐', icon: '📐' }
    ]
  },
  {
    id: 'tpl-10',
    name: '美食烹饪技能包',
    icon: '🍳',
    description: '家常菜谱、烹饪技巧与营养搭配...',
    category: 'life',
    subType: 'pack',
    downloadCount: '16.5w',
    isPaid: false,
    skills: [
      { name: '菜谱推荐', icon: '🍲' },
      { name: '食材搭配', icon: '🥬' },
      { name: '烹饪步骤', icon: '🔪' },
      { name: '营养分析', icon: '🥗' }
    ]
  },
  {
    id: 'tpl-11',
    name: '数据集处理技能包',
    icon: '🗂',
    description: '数据清洗、转换、可视化一站式...',
    category: 'internet',
    subType: 'dataset',
    downloadCount: '3.2w',
    isPaid: true,
    skills: [
      { name: '数据清洗', icon: '🧹' },
      { name: '格式转换', icon: '🔄' },
      { name: '数据可视化', icon: '📊' },
      { name: '异常检测', icon: '⚠️' }
    ]
  },
  {
    id: 'tpl-12',
    name: '全能写作助手',
    icon: '✏️',
    description: '文案撰写、润色、翻译一站式...',
    category: 'other',
    subType: 'pack',
    downloadCount: '56.7w',
    isPaid: false,
    skills: [
      { name: '文章润色', icon: '✨' },
      { name: '多语种翻译', icon: '🌐' },
      { name: '创意写作', icon: '💡' },
      { name: '校对纠错', icon: '🔍' }
    ]
  }
]

export const defaultMessages = {
  1: [
    {
      id: 'welcome-msg',
      role: 'assistant',
      type: 'text',
      content: '我是你的私人助手，我可以为你查询天气，搜索资料，规划行程路线等。',
      timestamp: Date.now()
    }
  ]
}

export function formatTime(timestamp) {
  const date = new Date(timestamp)
  const now = new Date()
  const isToday = date.toDateString() === now.toDateString()

  if (isToday) {
    return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
  }
  return date.toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' })
}

export function formatFileSize(bytes) {
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
}

export async function mockWebSearch(query) {
  await delay(800)
  return {
    results: [
      {
        title: `关于 "${query}" 的搜索结果 1`,
        url: 'https://example.com/result1',
        snippet: `这是关于 ${query} 的相关信息。联网搜索可以帮助你获取最新的资讯和数据。`
      },
      {
        title: `关于 "${query}" 的搜索结果 2`,
        url: 'https://example.com/result2',
        snippet: `${query} 是一个热门话题，以下是一些相关的参考资料和讨论。`
      },
      {
        title: `关于 "${query}" 的搜索结果 3`,
        url: 'https://example.com/result3',
        snippet: `深入了解 ${query} 的最新动态和趋势分析。`
      }
    ]
  }
}

export async function mockAiReply(content, options = {}) {
  await delay(1000 + Math.random() * 1000)

  let reply = `收到你的消息："${content.slice(0, 50)}${content.length > 50 ? '...' : ''}"\n\n`

  if (options.model && options.model !== 'auto') {
    reply += `🧠 **模型**: ${options.model}\n\n`
  }

  reply += '这是一个演示回复。你可以接入真实的 AI API（如 OpenAI、Claude 等）来获取智能回答。'

  return reply
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
